import React, { useState, useEffect } from 'react';
import { 
  FaFacebookF, FaInstagram, FaWhatsapp, FaGoogle,
  FaEnvelope, FaMapMarkerAlt, FaArrowRight, 
  FaCrown, FaHeart, FaPhoneAlt
} from 'react-icons/fa';
import '../css/Footer.css';

export default function Footer() {
  const [emailInput, setEmailInput] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [currentPath, setCurrentPath] = useState('');

  useEffect(() => {
    setCurrentPath(window.location.pathname);
  }, []);

  const handleSubscribe = () => {
    if (emailInput) {
      setIsSubmitting(true);
      const recipientEmail = 'swetarita25786@gmail.com';
      const subject = encodeURIComponent('Newsletter Subscription Request');
      const body = encodeURIComponent(`Dear No Brokerage Paying Guest Team,\n\nPlease subscribe me to your newsletter. My email address is: ${emailInput}\n\nThank you.`);
      const mailtoLink = `mailto:${recipientEmail}?subject=${subject}&body=${body}`;
      window.location.href = mailtoLink;
      setEmailInput('');
      setTimeout(() => {
        setIsSubmitting(false);
        alert('Thank you for subscribing!');
      }, 500);
    } else {
      alert('Please enter your email address.');
    }
  };

  // Helper function to check if link is active
  const isActive = (path) => {
    return currentPath === path;
  };

  return (
    <footer className="footer-medium">
      <div className="footer-medium-container">
        {/* Logo & About */}
        <div className="footer-medium-col">
          <div className="footer-medium-logo">
            <FaCrown className="footer-medium-icon" />
            <span>No Brokerage Paying Guest</span>
            <span className="footer-badge">LUXURY</span>
          </div>
          <p className="footer-medium-text">
            Mumbai's premier choice for comfortable, secure, and vibrant co-living spaces and PGs. We believe that finding the perfect home should be simple and stress-free. That's why we offer fully furnished accommodations with zero brokerage, premium amenities, and 24/7 security – all designed to give you peace of mind.
          </p>
        </div>

        {/* Quick Links */}
        <div className="footer-medium-col">
          <h4>Quick Links</h4>
          <ul>
            <li>
              <a href="/" className={isActive('/') ? 'active-link' : ''}>Home</a>
            </li>
            <li>
              <a href="/properties" className={isActive('/properties') ? 'active-link' : ''}>Properties</a>
            </li>
            
            <li>
              <a href="/gallery" className={isActive('/gallery') ? 'active-link' : ''}>Gallery</a>
            </li>
            <li>
              <a href="/faq" className={isActive('/faq') ? 'active-link' : ''}>FAQs</a>
            </li>
            <li>
              <a href="/contact" className={isActive('/contact') ? 'active-link' : ''}>Contact Us</a>
            </li>
          </ul>
        </div>

        {/* Info Links */}
        <div className="footer-medium-col">
          <h4>Information</h4>
          <ul>
            <li>
              <a href="/about" className={isActive('/about') ? 'active-link' : ''}>About Us</a>
            </li>
            <li>
              <a href="/PrivacyPolicy" className={isActive('/PrivacyPolicy') ? 'active-link' : ''}>Privacy Policy</a>
            </li>
            <li>
              <a href="/TermsAndConditions" className={isActive('/TermsAndConditions') ? 'active-link' : ''}>Terms & Conditions</a>
            </li> 
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-medium-col">
          <h4>Contact Info</h4>
          <div className="footer-medium-contact">
            <FaWhatsapp />
            <a href="https://wa.me/918879779777" target="_blank" rel="noopener noreferrer">+91 8879779777</a>
          </div>
          <div className="footer-medium-contact">
            <FaPhoneAlt />
            <a href="tel:+919820779777">+91 9820779777</a>
          </div>
          <div className="footer-medium-contact">
            <FaEnvelope />
            <a href="mailto:swetarita25786@gmail.com">swetarita25786@gmail.com</a>
          </div>
          <div className="footer-medium-contact">
            <FaMapMarkerAlt />
            <a href="https://maps.app.goo.gl/7wLJNZ2rJWTEdU1r5" target="_blank" rel="noopener noreferrer">
              Pandit Solicitor Road, Opposite Blue Diamond, Malad East, Mumbai - 400097
            </a>
          </div>
        </div>

        {/* Newsletter */}
        <div className="footer-medium-col">
          <h4>Newsletter</h4>
          <p className="footer-newsletter-text">Stay updated with our latest offerings.</p>
          <div className="footer-medium-newsletter">
            <input
              type="email"
              placeholder="Enter your email"
              value={emailInput}
              onChange={(e) => setEmailInput(e.target.value)}
            />
            <button onClick={handleSubscribe} disabled={isSubmitting}>
              {isSubmitting ? '...' : <FaArrowRight />}
            </button>
          </div>
        </div>
      </div>

      {/* Social Bar */}
      <div className="footer-medium-social">
        <div className="footer-medium-social-inner">
          <span>FOLLOW LUXURY LIVING</span>
          <div className="footer-medium-social-icons">
            <a href="https://share.google/fPIgRUSA8uh983Pv4" target="_blank" rel="noopener noreferrer">
              <FaGoogle />
            </a>
            <a href="https://www.instagram.com/no_brokerage_payingguest/" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>
            <a href="https://www.facebook.com/profile.php?id=61579151297192" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>
            <a href="https://wa.me/918879779777" target="_blank" rel="noopener noreferrer">
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="footer-medium-bottom">
        <p>&copy; {new Date().getFullYear()} No Brokerage Paying Guest. All rights reserved. Designed & Developed by <span>Mark Digital</span></p>
      </div>
    </footer>
  );
}